import api from '../../config/http-common'

const buildQuery = (filter) => {
  let query = '?pageNumber=' + filter.pageNumber + '&pageSize=' + filter.pageSize

  return query
}

const getDeviceTypeList = (filter) => {
  return api.securedAxios().get('/api/v4/web/deviceTypes/list' + buildQuery(filter))
}

const updateDeviceType = (payload) => {
  return api.securedAxios().put('/api/v4/web/deviceTypes/' + payload.get('id'), payload)
}

const downloadAPKFileById = (payload) => {
  return api.securedAxios().post('/api/v4/web/deviceType/' + payload.id + '/download/apk'+"?deviceModel=" +payload.deviceModel + "&fileName="+payload.fileName);
};

const DeviceTypeService = {
  getDeviceTypeList,
  updateDeviceType,
  downloadAPKFileById
}

export default DeviceTypeService
